import styled, { css } from 'styled-components'
import { Table } from 'semantic-ui-react'

import Text from '../../Text'

export const TableRow = styled(({ clickable, ...props }) => (
  <Table.Row {...props} />
))`
  ${({ theme, clickable }) => css`
    &&& {
      color: ${theme.primaryFontColor};
      transition: 0.1s background-color, color;

      ${
        clickable &&
        css`
          &,
          * {
            cursor: pointer;
          }
        `
      }

      
      ${theme.mediaQueries.desktop} {
        &:hover {
          background-color: ${clickable ? theme.colors.lightGrey : 'initial'};

          a {
            color: initial;
          }
        }
      }
  `}
`

export const MobileCell = styled.div`
  display: grid;
  grid-template-columns: 40% 60%;
  align-items: center;
  padding: 8px;
  background: #fff;
  border-radius: 3px;
`

export const MobileSpan = styled(Text.Span)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`
